import styled from 'styled-components';

export const Field = styled.div`
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const Label = styled.label`
  margin-bottom: 10px;
  display: block;
`;
